import React from 'react'
import { FormattedMessage } from 'react-intl'

export const ACTIVITY_TYPES = [
  { _id: 'SERVICES', name: <FormattedMessage id="services" /> },
  { _id: 'WASHES', name: <FormattedMessage id="washes" /> },
  {
    _id: 'SERVICES_AND_WASHES',
    name: <FormattedMessage id="servicesAndWashes" />,
  },
]

export const ACTIVITY_TYPES_ENUM = {
  SERVICES: 'SERVICES',
  WASHES: 'WASHES',
  SERVICES_AND_WASHES: 'SERVICES_AND_WASHES',
}

// export const ACTIVITY_TYPES = [
//     { id: 'wash', name: <FormattedMessage id='wash' /> },
//     { id: 'service station', name: <FormattedMessage id='service.station' /> },
//     { id: 'service.wash', name: <FormattedMessage id='service.wash' /> },
// ]
